import { render, staticRenderFns } from "./TradeDeals.vue?vue&type=template&id=7a021950&scoped=true&"
import script from "./TradeDeals.vue?vue&type=script&lang=js&"
export * from "./TradeDeals.vue?vue&type=script&lang=js&"
import style0 from "./TradeDeals.vue?vue&type=style&index=0&id=7a021950&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a021950",
  null
  
)

export default component.exports